import { getNumberFromFilterPrimitive, formatDollarsByRange } from '..';

const ranges: FormatDollarsRange[] = [
    {
        max: 1000,
        style: 'standard',
        precision: 6,
    },
    {
        max: 1000000000,
        style: 'standard',
        precision: 2,
    },
    {
        max: Infinity,
        style: 'compact',
        precision: 1,
    },
];

/**
 * Formats a dollar amount according to a specific set of rules:
 * 1. For values up to 1000, rounds to 6 decimal places of precision, and pads zeroes up to two
 * decimal places
 *      Example: 1.00026 => '$1.0003'
 *      Example: 1.1 => '$1.10'
 * 2. For values up to 1 billion, rounds to 2 decimal places of precision and pads zeroes up to
 * tqo decimal places
 *      Example: 233.332 => '$233.33'
 *      Example: 566.9 => '$566.90'
 * 3. For values over 1 billion, uses roman numeral notation with one decimal place of precision
 * i.e. '$1.1M'
 *      Example: 1233000000.123 => '$1.2B'
 * @param {number} value a dollar amount
 */
export const formatDollarsEarningsFilter = (
    filterPrimitive: PreFilterPrimitive,
    defaultValue: number,
): string => {
    if (typeof filterPrimitive === 'number' && !Number.isNaN(filterPrimitive)) {
        return formatDollarsByRange({ value: filterPrimitive, ranges });
    }

    const parsedValue = getNumberFromFilterPrimitive(
        filterPrimitive,
        defaultValue,
    );

    return formatDollarsByRange({ value: parsedValue, ranges });
};
